import * as React from 'react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import HubspotMeetingsWrapper from 'modules/onboarding/components/HelpWidget/WidgetSidepanel/HubspotMeetingsWrapper'
import { MeetingPayload } from 'modules/onboarding/lib/hubspot/meetings'

interface MeetingBookingModalProps {
  onClose: () => void
  onMeetingBooked: (data: MeetingPayload) => void
}

const MeetingBookingModal = ({ onClose, onMeetingBooked }: MeetingBookingModalProps) => {
  return (
    <Modal
      title={i18n.t('upsell.book_a_meeting')}
      onClose={() => {
        onClose()
      }}
    >
      <HubspotMeetingsWrapper isUpsellMeeting onMeetingBooked={onMeetingBooked} />
    </Modal>
  )
}

export default MeetingBookingModal
